export default __webpack_public_path__ + "images/assets/4ce0838bb59fe97a61cd49c0cb6130fd.svg";